import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { SharedService } from '../../Services/shared.service';

export interface ToastMessage {
  severity: 'success' | 'info' | 'warn' | 'error';
  summary?: string;
  detail: string;
  life?: number;
}
@Component({
  selector: 'app-toast',
  imports: [Toast],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  providers: [MessageService],
  standalone: true,
})
export class ToastComponent {
  constructor(private messageService: MessageService , private sharedS:SharedService) {
    this.sharedS.getToastSubject().subscribe((toastMessage: ToastMessage) => {
      this.show(toastMessage);
    });
  }

  show(toastMessage: ToastMessage) {
    const summaryMap = {
      success: 'Success',
      info: 'Info',
      warn: 'Warn',
      error: 'Error',
    };

    this.messageService.add({
      severity: toastMessage.severity,
      summary: toastMessage.summary ?? summaryMap[toastMessage.severity],
      detail: toastMessage.detail,
      life: toastMessage.life ?? 3000,
    });
  }
}
